@if (review(); as review) {
  <rma-star-rating [overallStars]="review.ratings" />
  <p class="my-3 grow text-sm text-steel-80" [class.line-clamp-5]="lineClamp" [innerHTML]="review.review"></p>
  <span class="flex items-center text-sm text-steel-70">
    @if (source(); as sourceValue) {
      <img
        class="mr-2 w-6"
        [src]="'assets/images/external-reviews/v2/' + sourceValue + '.svg' | lowercase | staticAssetUrl"
        [alt]="sourceValue"
        loading="lazy"
      />
      {{ 'externalReviews.source.' + sourceValue | transloco }}
    }
  </span>
}
